<template>
	<div class="FStoRecords">
		<div class="tit">
			<span>管理预约箱格</span>
			<transition name="el-zoom-in-center">
				<el-input v-model="keyword.value" placeholder="快递号查询" class="serach" v-show="showSearch">
					<el-button slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</transition>
			<div :class="[showSearch ? 'el-icon-zoom-out': 'el-icon-zoom-in','checkBtn']" @click="showSearch = !showSearch"></div>
		</div>
		<div class="list">
			<div class="item">
				<div>
					<div class="itName">
						<span class="itText">快递号:<span class="it-Cont">30212131454646</span></span>
					</div>
					<div class="itTips">
						<span class="itText">收件人手机号:<span>15016673106</span></span>
					</div>
					<div class="itTips">
						<span class="itText">状态:<span class="itEm">未取件</span></span>
						<span class="itText">派件时间:<span>2020-12-12 12:12:12</span></span>
					</div>
				</div>
			</div>
			
		</div>
		
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit"></EConfigBtn>	
	</div>
</template>

<script>
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import { EloginApi } from '../../../../static/FreshCabinet/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	var vm
	export default {
		name:'FStoRecords',
		data() {
			return {
				configStorage:null,
				userInfo:null,

				showSearch:false,//是否显示搜索
				keyword:{
					value:'',//关键词搜索
				},
				
				unOrdersData:[],//列表数据
				
				isLanguage:0,
				Language:'',
			};
		},
		created(){
			vm = this
			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				this.configStorage = configStorage
			}
			var userInfo = storage.localGetItem('userInfo');
			if(userInfo){
				this.userInfo = userInfo
			}
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
			// this.getStoragedOrders()
		},
		components:{
			EConfigBtn,
		},
		methods:{
			//获取已入库的订单
			async getStoragedOrders(){
				let data = {
					'cabinet_id':vm.configStorage.deviceId,//设备id
					'sender_phone':vm.userInfo.phone_no,//派件人电话
					'first_row':0,//当前页,从0开始
					'list_rows':9999,//每页数量
				}
				conLog('订单列表',data)
				let res = await EloginApi.getStoragedOrders(data)
				if(res){
					if(res.meta.code == 200){
						conLog('订单列表',res)
						for(var i in res.body){
							res.body[i].boxNum = res.body[i].box_id.replace(vm.configStorage.deviceId,"");
						}
						vm.OrdersData = res.body
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//返回上一页
			backUp(){
				vm.$router.push({
					path:'/FreshCabinet/FWarehousList',
				})
			},
			//退出登录
			quit(){
				storage.localRemoveItem('courierToken')
				storage.localRemoveItem('userInfo')
				vm.$router.push({
					path:'/FreshCabinet',
				})
			}
		}
	}
</script>

<style lang="less">
.FStoRecords{
	
	.list{
		background: #fff;
		overflow: auto;
		position: absolute;
		left: 0;
		right: 0;
		top: 1.2rem;
		bottom: 0.8rem;
		.item{
			color: #151c36;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0.2rem;
			border-bottom: 0.02rem solid #555;
			.itCheckbox{
				font-size: 0.36rem;
				color: #409EFF;
				box-shadow: 0 0.02rem 0.02rem 0.02rem rgba(0, 0, 0, .12);
			}
			.itName{
				font-size: 0.36rem;
			}
			.itTips{
				font-size: 0.3rem;
				color: #888;
				margin: 0.1rem 0;
				.itEm{
					background: #009688;
					color: #fff;
					border-radius: 0.1rem;
					padding: 0.05rem 0;
				}
			}
			.itText{
				margin-right: 0.7rem;
				.it-Cont{
					font-style: normal;
					margin-left: 0.3rem;
				}
			}
		}
	}
	.tit{
		position: relative;
		background: #151c36;
		height: 1.2rem;
		line-height: 1.2rem;
		font-size: 0.45rem;
		text-align: center;
		.wareLog{
			font-size: 0.3rem;
			line-height: 1;
			position: absolute;
			right: 0.3rem;
			top: 35%;
		}
		.checkBtn{
			font-size: 0.4rem;
			line-height: 1;
			position: absolute;
			right: 4rem;
			top: 25%;
			padding: 0.1rem;
		}
		.serach{
			width: 40%;
			position: absolute;
			left: 50%;
			margin-left: -20%;
			top: 50%;
			height: 0.8rem;
			margin-top: -0.4rem;
			font-size: 0.3rem;
			z-index: 2;
			.el-input-group__append{
				background: #151c36;
				color: #fff;
				border-radius: 0;
				border: none;
				border-bottom: 0.02rem solid #fff;
			}
			.el-input__inner{
				height: 0.8rem;
				line-height: 0.8rem;
				border-radius: 0;
				border: none;
				border-bottom: 0.02rem solid #fff;
				background: #151c36;
				color: #fff;
			}
			
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/FreshCabinet/StoRecords/StoRecords.vue